const ScaleIndex = () => import("./scales/index.vue");
const CreateScalePage = () => import("./scales/_pages/create.vue");
const ViewScalePage = () => import("./scales/_pages/view.vue");

const CategoryIndex = () => import("./consumable-categories/index.vue");
const CreateCategoryPage = () => import("./consumable-categories/_pages/create.vue");
const ViewCategoryPage = () => import("./consumable-categories/_pages/view.vue");

// projects 
const ProjectIndex = () => import("./projects/index.vue");
const CreateProjectPage = () => import("./projects/_pages/create.vue");
const ViewProjectPage = () => import("./projects/_pages/view.vue");
const ProjectEmployees = () => import("./projects/_pages/employees.vue");
const ProjectConsumables = () => import("./projects/_pages/consumables.vue");

// requisitions approval
const ApprovalIndex = () => import("./approvals/index.vue");
const RequisitionConsumables = () => import("./approvals/_pages/consumables.vue");

// approved requisitions
const ApprovedIndex = () => import("./approved-requisitions/index.vue");
const RequisitionPreview = () => import("./approved-requisitions/_pages/consumables.vue");


export default [
  {
    path: "/scales",
    component: ScaleIndex,
  },
  {
    path: "/new-scale",
    component: CreateScalePage,
  },
  {
    path: "/scales/:id",
    component: ViewScalePage,
  },
  {
    path: "/projects",
    component: ProjectIndex,
  },
  {
    path: "/new-project",
    component: CreateProjectPage,
  },
  {
    path: "/projects/:id",
    component: ViewProjectPage,
  },
  {
    path: "/projects/employees/:id",
    component: ProjectEmployees,
  },
  {
    path: "/projects/consumables/:id",
    component: ProjectConsumables,
  },
  {
    path: "/consumable-categories",
    component: CategoryIndex,
  },
  {
    path: "/new-consumable-category",
    component: CreateCategoryPage,
  },
  {
    path: "/consumable-categories/:id",
    component: ViewCategoryPage,
  },
  {
    path: "/requisitions-approval",
    component: ApprovalIndex,
  },
  {
    path: "/requisitions-approval/:projectId/:phase",
    component: RequisitionConsumables,
  },
  {
    path: "/approved-requisitions",
    component: ApprovedIndex,
  },
  {
    path: "/requisitions-preview/:projectId/:phase",
    component: RequisitionPreview,
  },
];